import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { resources } from "./resources";
import { HTML_LANG, normalizeLanguage } from "./languages";

function updateDocumentLanguage(lng) {
  const lang = normalizeLanguage(lng);
  document.documentElement.lang = HTML_LANG[lang];
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "pt",
    supportedLngs: ["pt", "en", "es"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "mallupay-lang",
      convertDetectedLanguage: (lng) => normalizeLanguage(lng),
    },
    defaultNS: "common",
    ns: [
      "common",
      "landing",
      "malluLanding",
      "account",
      "foru",
      "forujob",
      "garantias",
      "forms",
      "legalSecurityCiber",
      "legalSecurityDados",
      "legalSecurityUses",
      "legalOuvidoria",
      "legalAccountCancellation",
      "legalContratoPF",
      "legalContratoPJ",
      "legalGarantias",
    ],
  });

i18n.on("languageChanged", updateDocumentLanguage);
updateDocumentLanguage(i18n.language);

export default i18n;
